"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewGameModeLayer = void 0;
var GameManager_1 = require("./../../../GameManager");
var GameVars_1 = require("../../../GameVars");
var GameConstants_1 = require("../../../GameConstants");
var AudioManager_1 = require("../../../AudioManager");
var NewGameModeLayer = /** @class */ (function (_super) {
    __extends(NewGameModeLayer, _super);
    function NewGameModeLayer(scene) {
        var _this = _super.call(this, scene) || this;
        var d = 0;
        while (d < GameVars_1.GameVars.gameWidth) {
            var strip = new Phaser.GameObjects.Image(_this.scene, d, 0, "texture_atlas_0", GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "bg_strip" : "bg_strip_2");
            strip.setOrigin(0, 0);
            strip.setScale(GameVars_1.GameVars.gameHeight / strip.height);
            _this.add(strip);
            d += strip.width * GameVars_1.GameVars.gameHeight / strip.height;
        }
        var scaledItemsContainer = new Phaser.GameObjects.Container(_this.scene);
        scaledItemsContainer.x = GameVars_1.GameVars.gameWidth / 2;
        scaledItemsContainer.y = GameVars_1.GameVars.gameHeight / 2;
        if (!GameVars_1.GameVars.isDesktop) {
            if (GameVars_1.GameVars.aspectRatio > 1.5) {
                scaledItemsContainer.setScale(1.25, 1.25 * GameVars_1.GameVars.scaleY);
            }
            else {
                scaledItemsContainer.scaleY = GameVars_1.GameVars.scaleY;
            }
        }
        _this.add(scaledItemsContainer);
        var titleBackground = new Phaser.GameObjects.Image(_this.scene, 0, -310, "texture_atlas_0", "title_cookie_base");
        titleBackground.setScale(.4);
        scaledItemsContainer.add(titleBackground);
        var title = new Phaser.GameObjects.Image(_this.scene, 0, -330, "texture_atlas_0", "title_merge_cakes");
        title.setScale(.4);
        scaledItemsContainer.add(title);
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            var titleBackground_1 = new Phaser.GameObjects.Image(_this.scene, 0, -100, "texture_atlas_0", "title_cookie_base");
            scaledItemsContainer.add(titleBackground_1);
            var title_1 = new Phaser.GameObjects.Image(_this.scene, 0, -100, "texture_atlas_1", "title_cake_house");
            scaledItemsContainer.add(title_1);
            var labelStr = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["NEW_GAME_MODE_DESCRIPTION_ITEM_1"];
            var label = new Phaser.GameObjects.Text(_this.scene, 0, -230, labelStr, { fontFamily: "Baloo", fontSize: "36px", align: "center", color: "#773c2e" });
            label.setOrigin(.5);
            scaledItemsContainer.add(label);
        }
        else {
            var title_2 = new Phaser.GameObjects.Image(_this.scene, 0, -100, "texture_atlas_1", "title_pastry_saloon");
            scaledItemsContainer.add(title_2);
            var labelStr = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["NEW_GAME_MODE_DESCRIPTION_ITEM_2"];
            var label = new Phaser.GameObjects.Text(_this.scene, 0, -230, labelStr, { fontFamily: "Baloo", fontSize: "36px", align: "center", color: "#6433b1" });
            label.setOrigin(.5);
            scaledItemsContainer.add(label);
        }
        var glowImage = new Phaser.GameObjects.Image(_this.scene, 0, 120, "texture_atlas_1", "radial_new_cake_mistery_box");
        glowImage.setScale(1.25);
        glowImage.blendMode = Phaser.BlendModes.SCREEN;
        scaledItemsContainer.addAt(glowImage);
        _this.scene.tweens.add({
            targets: glowImage,
            scaleX: 1.5,
            scaleY: 1.5,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 750,
            yoyo: true,
            repeat: -1
        });
        _this.scene.tweens.add({
            targets: glowImage,
            angle: 360,
            ease: Phaser.Math.Easing.Linear,
            duration: 4250,
            repeat: -1
        });
        var cell = new Phaser.GameObjects.Image(_this.scene, 0, 120, "texture_atlas_1", GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "base" : "base_2");
        scaledItemsContainer.add(cell);
        var item = new Phaser.GameObjects.Image(_this.scene, 0, 105, GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "texture_atlas_2" : "texture_atlas_3", GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "cake_1" : "biscuits_1");
        item.setScale(.75);
        scaledItemsContainer.add(item);
        _this.scene.time.addEvent({ delay: 1650, callback: function () {
                AudioManager_1.AudioManager.playSound(GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "cake_house_soundtrack" : "pastry_saloon_soundtrack", true);
                GameVars_1.GameVars.paused = false;
                GameManager_1.GameManager.enterBoardScene();
            }, callbackScope: _this });
        return _this;
    }
    return NewGameModeLayer;
}(Phaser.GameObjects.Container));
exports.NewGameModeLayer = NewGameModeLayer;
